(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MultipleCommandsController', MultipleCommandsController);

    MultipleCommandsController.$inject = ['$scope', '$state', '$http', '$timeout', 'TabActions', 'TabObjects', 'TabActionsQueue', 'AlertService', 'ParseLinks', 'Macro', 'CommandManifest', 'pagingParams'];

    function MultipleCommandsController($scope, $state, $http, $timeout, TabActions, TabObjects, TabActionsQueue, AlertService, ParseLinks, Macro, CommandManifest, pagingParams) {
        var vm = this;

        vm.total = 0;
        vm.onlyOnline = false;
        vm.commandToSend = false;
        vm.tabActions = [];
        vm.macro = [];
        vm.tabCommands = [];
        vm.tabMacro = [];
        vm.objectToUdp = [];
        vm.selectionValue = [];
        vm.pagesChecked = [];
        vm.predicates = {};
        vm.currentPage = 0;
        vm.tabActionsQueue = {commands: [], object: []};
        vm.charToSearch = pagingParams.search;
        vm.currentState = "multiple-commands";
        vm.currentStateFilter = "multiple-commands-filter";
        vm.showTable = false;
        vm.applyFilter = applyFilter;
        vm.selectedFleet = {};
        vm.selectedObjectType = {};
        vm.selectedFleets = [];
        vm.selectedCondition = {};
        vm.selectedObjectTypes = [];
        vm.fleet = {};
        vm.objectType = {};
        vm.showWarning = false;
        vm.filter = localStorage.getItem(vm.currentStateFilter);
        vm.hasGreengrassSelected = false;
        vm.greengrassCount = 0;
        vm.isGreengrassObjectType = false;
        vm.objectTypeCache = {};
        vm.filterApplied = false;
        vm.isInitializing = true;

        // Initialize filter and check Greengrass state
        function initializeController() {
            if (vm.filter !== null && vm.filter !== "null" && vm.filter !== undefined) {
                try {
                    vm.filter = JSON.parse(vm.filter);
                    if (Object.keys(vm.filter).length > 0) {
                        vm.selectedFleet.id = vm.filter.fleet;
                        vm.selectedObjectType.id = vm.filter.objectType;

                        // Check if it's Greengrass synchronously if possible
                        if (vm.selectedObjectType.id) {
                            checkAndSetGreengrassState().then(function() {
                                vm.isInitializing = false;
                            });
                        } else {
                            vm.isInitializing = false;
                        }
                    } else {
                        vm.isInitializing = false;
                    }
                } catch (e) {
                    console.error('Error parsing filter:', e);
                    vm.filter = {};
                    vm.isInitializing = false;
                }
            } else {
                vm.filter = {};
                vm.isInitializing = false;
            }
        }

        // Initialize on controller load
        initializeController();

        // Watch for ObjectType changes and reset state
        $scope.$watch('vm.selectedObjectType', function(newValue, oldValue) {
            if (newValue !== oldValue && newValue && newValue.id) {
                console.log('ObjectType changed:', newValue);

                // Reset state when ObjectType changes
                if (oldValue && oldValue.id && oldValue.id !== newValue.id) {
                    resetStateOnObjectTypeChange();
                }

                vm.checkIfObjectTypeIsGreengrass(newValue);
            }
        }, true);

        // Watch for filter changes and update filterApplied flag
        $scope.$watch('[vm.selectedFleet.id, vm.selectedObjectType.id]', function(newValues, oldValues) {
            if (newValues[0] !== oldValues[0] || newValues[1] !== oldValues[1]) {
                if (vm.filterApplied && (newValues[0] !== vm.filter.fleet || newValues[1] !== vm.filter.objectType)) {
                    console.log('Filter parameters changed - marking as not applied');
                    vm.filterApplied = false;
                    // Clear selections when filter changes
                    vm.clearObjectList();
                }
            }
        }, true);

        function checkAndSetGreengrassState() {
            var deferred = $http.get('api/tab-object-types/' + vm.selectedObjectType.id);

            return deferred.then(function(response) {
                var fullObjectType = response.data;
                vm.objectTypeCache[vm.selectedObjectType.id] = fullObjectType;

                if (fullObjectType && fullObjectType.greengrassType === true) {
                    vm.isGreengrassObjectType = true;
                    vm.filterApplied = true; // Mark as applied if coming from saved state
                    console.log('Greengrass ObjectType restored from saved state');
                } else {
                    vm.isGreengrassObjectType = false;
                    // Check if filter was applied for non-Greengrass
                    if (vm.filter && vm.filter.fleet && vm.filter.objectType) {
                        vm.filterApplied = true;
                    }
                }
                return fullObjectType;
            }).catch(function(error) {
                console.error('Error loading ObjectType:', error);
                vm.isGreengrassObjectType = false;
                return null;
            });
        }

        function resetStateOnObjectTypeChange() {
            console.log('Resetting state due to ObjectType change');
            vm.tabCommands = [];
            vm.tabMacro = [];
            vm.objectList = [];
            vm.objectToUdp = [];
            vm.selectionValue = [];
            vm.showTable = false;
            vm.filterApplied = false;
            vm.hasGreengrassSelected = false;
            vm.greengrassCount = 0;
            vm.areChk = false;
            vm.pagesChecked = [];
            vm.tabActions = [];
            vm.macro = [];
            vm.isGreengrassObjectType = false;

            // Update chosen selects
            $timeout(function() {
                $('#field_action').trigger('chosen:updated');
                $('#field_action_macro').trigger('chosen:updated');
            }, 100);
        }

        vm.loadAll = function () {
            var queryString = {
                page: 0,
                size: 2000,
                query: vm.charToSearch,
                fleet: vm.selectedFleet.id,
                objectType: vm.selectedObjectType.id
            };

            if (vm.isGreengrassObjectType) {
                console.log('Greengrass ObjectType - loading commands from manifest');
                vm.loadCommandsFromManifest();

/*                Macro.queryGreengrassByObjectType({
                    objectTypeId: vm.selectedObjectType.id,
                    fleetId: vm.selectedFleet.id,
                    page: 0
                }, onSuccessMacro, onErrorMacro);*/
            } else {
                TabActions.multiple(queryString, onSuccess, onError);

                Macro.byObjectType({
                    id: vm.selectedObjectType.id,
                    fleet: vm.selectedFleet.id,
                    page: 0
                }, onSuccessMacro, onErrorMacro);
            }

            function onSuccess(data, headers) {
                if(!queryString.fleet) {
                    vm.applyFilter(vm.selectedFleet.id, vm.selectedObjectType.id);
                } else {
                    vm.tabActions = data;
                    console.log('TabActions loaded (non-Greengrass):', vm.tabActions.length);

                    if (vm.filter == 'null' || vm.filter == null || vm.filter == undefined)
                        vm.filter = {};
                    localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));

                    $timeout(function() {
                        $('#field_action').trigger('chosen:updated');
                    }, 100);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            function onSuccessMacro(data) {
                vm.macro = [];
                for(var i = 0; i < data.length; i++){
                    vm.macro.push(data[i]);
                }

                console.log('Macros loaded:', vm.macro.length, 'isGreengrass:', vm.isGreengrassObjectType);

                $timeout(function() {
                    $('#field_action_macro').trigger('chosen:updated');
                }, 100);
            }

            function onErrorMacro() {
                vm.macro = [];
            }
        };

        vm.search = function () {
            vm.fetchObjects(1);
        };

        vm.fetchObjects = function(page) {
            vm.currentPage = page;

            // For Greengrass, verify filter has been applied
            if (vm.isGreengrassObjectType && !vm.filterApplied) {
                AlertService.error("Please apply filter before checking objects for Greengrass ObjectType");
                return;
            }

            if(vm.selectedFleet.id != vm.filter.fleet || vm.selectedObjectType.id != vm.filter.objectType) {
                AlertService.error("Apply filter before check objects");
                return;
            }

            // For Greengrass use a different API with online parameter from checkbox
            if (vm.isGreengrassObjectType) {
                console.log('Fetching objects for Greengrass with online=' + vm.onlyOnline);
                var queryString = {
                    page: page - 1,
                    size: 20,
                    query: vm.charToSearch,
                    //online: vm.onlyOnline,  // Use checkbox value instead of hardcoded true
                    fleetId: vm.selectedFleet.id,
                    typeId: vm.selectedObjectType.id,
                    cacheBuster: new Date().getTime()
                };

                if (vm.onlyOnline) {
                    queryString.online = true;
                }

                $http.get('api/tab-objects', {params: queryString}).then(function(response) {
                    var data = response.data;
                    var headers = response.headers;

                    vm.showTable = true;
                    vm.objectList = data;
                    vm.greengrassCount = 0;

                    if (data && data.length > 0) {
                        for (var i = 0; i < data.length; i++) {
                            if (data[i].objectType && data[i].objectType.greengrassType === true) {
                                vm.greengrassCount++;
                            }
                        }
                        if (vm.greengrassCount > 0) {
                            console.info('Found ' + vm.greengrassCount + ' Greengrass objects');
                        }
                    }

                    if(data.length > 0) {
                        var linkHeader = headers('link');
                        if (linkHeader) {
                            vm.links = ParseLinks.parse(linkHeader);
                        }
                        var totalCountHeader = headers('X-Total-Count');
                        vm.totalItems = totalCountHeader ? parseInt(totalCountHeader) : data.length;
                        if(vm.totalItems > vm.total){
                            vm.total = vm.totalItems;
                        }
                        if (vm.areChk || vm.checkNextPages)
                            pushAllObject();
                    } else {
                        vm.totalItems = 0;
                    }
                    vm.queryCount = vm.totalItems;
                }).catch(function(error) {
                    console.error('Error fetchObjects for Greengrass:', error);
                    AlertService.error('Error loading objects');
                });
            } else {
                // For non-Greengrass use normal byActions call
                var queryString = {
                    page: page - 1,
                    size: 20,
                    query: vm.charToSearch,
                    onlyOnline: vm.onlyOnline,
                    fleet: vm.selectedFleet.id,
                    objectType: vm.selectedObjectType.id
                };
                TabObjects.byActions(queryString, {commands: vm.tabCommands, macros: vm.tabMacro}, onSuccess, onError);
            }

            function onSuccess(data, headers) {
                vm.showTable = true;
                vm.objectList = data;
                vm.greengrassCount = 0;

                if (data && data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].objectType && data[i].objectType.greengrassType === true) {
                            vm.greengrassCount++;
                        }
                    }
                    if (vm.greengrassCount > 0) {
                        console.info('Found ' + vm.greengrassCount + ' Greengrass objects');
                    }
                }

                if(data.length > 0) {
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    if(vm.totalItems > vm.total){
                        vm.total = vm.totalItems;
                    }
                    if (vm.areChk || vm.checkNextPages)
                        pushAllObject();
                } else {
                    vm.totalItems = 0;
                }
                vm.queryCount = vm.totalItems;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        function applyFilter(fleet, objectType) {
            vm.showWarning = false;
            vm.tabCommands = [];
            vm.tabMacro = [];
            vm.macro = [];
            vm.objectList = [];
            vm.tabActions = [];
            vm.objectToUdp = [];
            vm.selectionValue = [];
            vm.showTable = false;
            vm.filterApplied = false;
            vm.areChk = false;
            vm.pagesChecked = [];

            if(fleet && fleet.id) {
                if(fleet.id > 0) {
                    vm.fleet = fleet;
                    vm.filter.fleet = fleet.id;
                } else {
                    vm.fleet = [];
                    vm.fleet = vm.selectedFleets;
                    vm.filter.fleet = -1;
                }
            }
            if(objectType && objectType.id && objectType.id > -1) {
                vm.objectType = objectType;
                vm.filter.objectType = objectType.id;

                // Re-check if it's Greengrass when applying filter
                if (vm.selectedObjectType && vm.selectedObjectType.greengrassType === true) {
                    vm.isGreengrassObjectType = true;
                    console.warn('Greengrass ObjectType detected in applyFilter');
                } else {
                    // Check from cache or API
                    vm.checkIfObjectTypeIsGreengrass(vm.selectedObjectType);
                }
            } else {
                vm.objectType.id = -1;
                vm.isGreengrassObjectType = false;
            }

            localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));

            // Wait a bit for Greengrass check to complete before loading
            $timeout(function() {
                vm.loadAll();
                vm.filterApplied = true;
                console.log('Filter applied - filterApplied:', vm.filterApplied, 'isGreengrassObjectType:', vm.isGreengrassObjectType);
            }, 100);
        }

        vm.checkIfObjectTypeIsGreengrass = function(objectType) {
            console.log('Checking ObjectType:', objectType);

            if (!objectType || !objectType.id) {
                vm.isGreengrassObjectType = false;
                return;
            }

            if (objectType.greengrassType === true) {
                vm.isGreengrassObjectType = true;
                console.warn('Greengrass ObjectType detected:', objectType);
                return;
            }

            if (objectType.greengrassType === false) {
                vm.isGreengrassObjectType = false;
                console.log('Non-Greengrass ObjectType confirmed:', objectType);
                return;
            }

            // Check cache first
            if (vm.objectTypeCache[objectType.id]) {
                console.log('ObjectType found in cache');
                var cachedObjectType = vm.objectTypeCache[objectType.id];
                if (cachedObjectType.greengrassType === true) {
                    vm.isGreengrassObjectType = true;
                    console.warn('Greengrass ObjectType detected (from cache):', cachedObjectType);
                } else {
                    vm.isGreengrassObjectType = false;
                }
                return;
            }

            // Load from API if not in cache and greengrassType property is missing
            console.log('Loading ObjectType details ID:', objectType.id);
            $http.get('api/tab-object-types/' + objectType.id)
                .then(function(response) {
                    var fullObjectType = response.data;
                    console.log('Full ObjectType received:', fullObjectType);
                    vm.objectTypeCache[objectType.id] = fullObjectType;

                    if (fullObjectType && fullObjectType.greengrassType === true) {
                        vm.isGreengrassObjectType = true;
                        console.warn('Greengrass ObjectType detected (after loading):', fullObjectType);
                    } else {
                        vm.isGreengrassObjectType = false;
                    }

                    // Update UI after async load
                    $timeout(function() {
                        $('#field_action').trigger('chosen:updated');
                    }, 50);
                })
                .catch(function(error) {
                    console.error('Error loading ObjectType:', error);
                    vm.isGreengrassObjectType = false;
                });
        };

        vm.loadCommandsFromManifest = function() {
            if (!vm.selectedObjectType || !vm.selectedObjectType.id) {
                console.warn('No ObjectType selected to load commands');
                return;
            }

            if (!vm.isGreengrassObjectType) {
                console.log('Non-Greengrass ObjectType, skip manifest loading');
                return;
            }

            console.log('Loading manifest for Greengrass ObjectType...');
            console.log('Fleet ID:', vm.selectedFleet.id);
            console.log('ObjectType ID:', vm.selectedObjectType.id);

            $http.get('api/tab-objects/with-manifest', {
                params: {
                    fleetId: vm.selectedFleet.id,
                    typeId: vm.selectedObjectType.id
                }
            })
                .then(function(response) {
                    var objectWithManifest = response.data;

                    console.log('Object with manifest found:', objectWithManifest.objectUniqueCode);
                    console.log('  Status:', objectWithManifest.objectOnline ? 'ONLINE' : 'OFFLINE');
                    console.log('  Last tick:', objectWithManifest.lastTick);

                    return CommandManifest.get({
                        objectUniqueCode: objectWithManifest.objectUniqueCode
                    }).$promise.then(function(manifestData) {
                        return {
                            manifest: manifestData,
                            sourceObject: objectWithManifest.objectUniqueCode,
                            objectStatus: objectWithManifest.objectOnline ? 'ONLINE' : 'OFFLINE',
                            lastTick: objectWithManifest.lastTick
                        };
                    });
                })
                .then(function(result) {
                    console.log('Manifest loaded successfully!');


                    AlertService.success(
                        'Commands loaded successfully'
                    );

                    // Processa il manifest
                    processManifestTemplate(
                        result.manifest,
                        result.sourceObject,
                        result.objectStatus,
                        result.lastTick
                    );
                })
                .catch(function(error) {
                    console.error('Error loading manifest:', error);

                    if (error.status === 404) {
                        AlertService.error(
                            'No commands available for this fleet and object type. '
                        );
                    } else {
                        AlertService.error('Error loading commands from manifest');
                    }

                    vm.tabActions = [];
                    vm.tabCommands = [];
                });
        };

        /**
         * Processa il manifest e lo salva in cache
         */
        function processManifestTemplate(manifestData, sourceObject, objectStatus, lastTick) {
            vm.tabActions = [];
            vm.tabCommands = [];

            if (!manifestData || !manifestData.manifest) {
                console.warn('Invalid manifest data');
                return;
            }

            console.log('Processing manifest template...');
            console.log('  Source object:', sourceObject);
            console.log('  Object status:', objectStatus);

            var commandIndex = 0;

            angular.forEach(manifestData.manifest, function(commands, componentName) {
                angular.forEach(commands, function(command) {
                    if (command.command_name) {
                        vm.tabActions.push({
                            id: 'manifest_' + commandIndex,
                            actionCommand: command.command_name,
                            description: command.description || command.command_name,
                            componentName: componentName
                        });
                        commandIndex++;
                    }
                });
            });

            console.log('Total commands loaded:', vm.tabActions.length);

            if (vm.tabActions.length === 0) {
                AlertService.warning('No commands available in manifest');
                return;
            }

            // Salva in cache
            var manifestCache = {
                manifest: manifestData,
                sourceObject: sourceObject,
                objectStatus: objectStatus,
                lastTick: lastTick,
                timestamp: new Date().toISOString(),
                objectTypeId: vm.selectedObjectType.id,
                fleetId: vm.selectedFleet.id,
                commandCount: vm.tabActions.length
            };

            var cacheKey = 'manifestTemplate_' + vm.selectedObjectType.id + '_' + vm.selectedFleet.id;
            localStorage.setItem(cacheKey, JSON.stringify(manifestCache));

            console.log('Manifest cached successfully');
            console.log('Loading Greengrass macros after manifest success...');
            Macro.queryGreengrassByObjectType({
                objectTypeId: vm.selectedObjectType.id,
                fleetId: vm.selectedFleet.id,
                page: 0
            }, function(data) {
                vm.macro = [];
                for(var i = 0; i < data.length; i++){
                    vm.macro.push(data[i]);
                }
                console.log('Greengrass macros loaded:', vm.macro.length);

                $timeout(function() {
                    $('#field_action_macro').trigger('chosen:updated');
                }, 100);
            }, function() {
                console.warn('Error loading Greengrass macros');
                vm.macro = [];
            });



            // Aggiorno filtro
            if (!vm.filter) vm.filter = {};
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));

            // Aggiorno UI
            $timeout(function() {
                var selectElement = $('#field_action');
                if (selectElement.data('chosen')) {
                    selectElement.trigger('chosen:updated');
                }
            }, 100);
        }





        function pushAllObject() {
            vm.checkNextPages = true;
            if(vm.pagesChecked.indexOf(vm.currentPage - 1) < 0 || vm.areChk) {
                $.each(vm.objectList, function (key, el) {
                    // Allow Greengrass objects to be selected - they'll be handled on the next page
                    if(vm.selectionValue.indexOf(el.objectUniqueCode) < 0) {
                        vm.selectionValue.push(el.objectUniqueCode);
                        vm.objectToUdp.push(el);
                    }
                });
                vm.pagesChecked.push(vm.currentPage - 1);
            }
        }

        vm.chkUnChkAll = function () {
            if (vm.areChk) {
                vm.objectToUdp = [];
                vm.selectionValue = [];
                vm.checkNextPages = false;
                vm.pagesChecked = [];
            } else {
                vm.objectToUdp = [];
                vm.selectionValue = [];

                if (vm.isGreengrassObjectType) {
                    var queryString = {
                        page: 0,
                        size: 2000,
                        query: vm.charToSearch,
                        //online: vm.onlyOnline,  // Use checkbox value instead of hardcoded true
                        fleetId: vm.selectedFleet.id,
                        typeId: vm.selectedObjectType.id,
                        cacheBuster: new Date().getTime()
                    };

                    if (vm.onlyOnline) {
                        queryString.online = true;
                    }

                    $http.get('api/tab-objects', {params: queryString}).then(function(response) {
                        onAllSuccess(response.data);
                        pushAllObject();
                    }).catch(function(error) {
                        onAllError(error);
                    });
                } else {
                    var queryString = {
                        page: 0,
                        size: 2000,
                        query: vm.charToSearch,
                        onlyOnline: vm.onlyOnline,
                        fleet: vm.selectedFleet.id,
                        objectType: vm.selectedObjectType.id
                    };
                    TabObjects.byActions(queryString, {commands: vm.tabCommands, macros: vm.macro}, onAllSuccess, onAllError);
                    pushAllObject();
                }
            }
            vm.areChk = !vm.areChk;
            vm.updateGreengrassSelectedFlag();
        };

        function onAllSuccess(data) {
            $.each(data, function (key, el) {
                // Allow all objects to be added, including Greengrass
                if(vm.selectionValue.indexOf(el.objectUniqueCode) < 0) {
                    vm.selectionValue.push(el.objectUniqueCode);
                    vm.objectToUdp.push(el);
                }
            });
        }

        function onAllError(error) {
            AlertService.error("Error retrieving objects");
        }

        vm.toggleSelection = function (data) {
            var idx = vm.selectionValue.indexOf(data.objectUniqueCode);
            if (idx > -1) {
                vm.selectionValue.splice(idx, 1);
                vm.objectToUdp.splice(idx, 1);
                if (vm.selectionValue.length < vm.total) {
                    vm.areChk = false;
                }
            } else {
                vm.selectionValue.push(data.objectUniqueCode);
                vm.objectToUdp.push(data);
                if (vm.selectionValue.length == vm.total){
                    vm.areChk = true;
                }
            }
            vm.updateGreengrassSelectedFlag();
        };

        vm.clearObjectList = function() {
            vm.objectList = [];
            vm.objectToUdp = [];
            vm.selectionValue = [];
            vm.areChk = false;
            vm.showTable = false;
            vm.hasGreengrassSelected = false;
            vm.greengrassCount = 0;
            vm.pagesChecked = [];
        };

        vm.updateGreengrassSelectedFlag = function() {
            vm.hasGreengrassSelected = false;
            for (var i = 0; i < vm.objectToUdp.length; i++) {
                if (vm.objectToUdp[i].objectType && vm.objectToUdp[i].objectType.greengrassType === true) {
                    vm.hasGreengrassSelected = true;
                    console.info('Greengrass objects selected - will be handled on next page');
                    break;
                }
            }
        };

        $scope.$watch('vm.objectToUdp', function(newValue, oldValue) {
            if (newValue !== oldValue) {
                vm.updateGreengrassSelectedFlag();
            }
        }, true);

        // Listen for state changes to reset state when leaving/returning
        $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            if (fromState.name === 'multiple-commands') {
                console.log('Leaving multiple-commands state');
            }
        });

        $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            if (toState.name === 'multiple-commands' && fromState.name !== '') {
                console.log('Returning to multiple-commands state');
                // Reinitialize to check Greengrass state
                if (vm.selectedObjectType && vm.selectedObjectType.id) {
                    vm.checkIfObjectTypeIsGreengrass(vm.selectedObjectType);
                }
            }
        });
    }
})();
